<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <v-row dense>
              <v-col cols="12">
                <strong>Print Barcode Relasi</strong>
              </v-col>
            </v-row>
            <hr />
            <v-row class="mt-4">
              <!-- <v-col cols="3" md="3">
                <v-autocomplete
                  v-model="branch"
                  :items="branchList"
                  item-text="BRANCH_CODE"
                  :disabled="!isSuperUser"
                  label="Branch"
                  color="red darken-1"
                  outlined
                  dense
                />
              </v-col> -->
              <v-col cols="3" md="3">
                <v-autocomplete
                  v-model="position"
                  :items="positionList"
                  item-text="POSITION_DESC"
                  label="Position"
                  color="red darken-1"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="3" md="3">
                <v-btn @click="getRelasiPrintList" color="error" :disabled="dtLoading">
                  Load List
                </v-btn>
              </v-col>
            </v-row>

            <!-- Relasi Table -->
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <!-- Table Head -->
                  <v-card-title>
                    <v-spacer />
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    />
                  </v-card-title>

                  <!-- Table Content -->
                  <v-data-table
                    :headers="dtHeaders"
                    :items="dtItems"
                    :search="searchRole"
                    :loading="dtLoading"
                    loading-text="Fetching Data..."
                    dense
                  >
                    <!-- Custom "Date Print" formatting -->
                    <template v-slot:item.LAST_UPDATE_PRINT="{ item }">
                      <span v-show="item.LAST_UPDATE_PRINT">
                        {{ moment(item.LAST_UPDATE_PRINT).format('YYYY-MM-DD HH:mm:ss') }}
                      </span>
                    </template>

                    <!-- Reprint button -->
                    <template v-slot:item.ShouldReprint="{ item }">
                      <span v-show="item.ShouldReprint">
                        <v-btn
                          small
                          outlined
                          color="error"
                          class="reprint-button"
                          @click="printQRSingleRelation(item)"
                        >
                          Reprint
                        </v-btn>
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="end">
              <v-col cols="auto">
                <v-btn :disabled="isPrintDisabled" @click="printQRAllRelations" color="error">
                  Print All
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- <a target="_blank" rel="noreferrer noopener" href="https://www.zebra.com/ap/en/support-downloads/printer-software/by-request-software.html#browser-print">
        Unduh Zebra Browser Print
      </a> -->
    </v-container>

    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>

    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </Main>
</template>

<style>
thead.v-data-table-header > tr > th > div {
  display: inline-block;
  width: 90%;
}

thead.v-data-table-header > tr > th > div.v-input label {
  font-size: 12px;
}

.reprint-button {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>

<script>
import Main from "@/Main.vue";

import Handlebars from 'handlebars';
import moment from 'moment';

import {
  getDefaultDevice,
  getLocalDevices,
  getPrinterStatus,
  print,
  ZPLTemplate,
} from '../../../lib/zebra';

const dtHeaders = [
  {
    text: "Branch",
    value: "BRANCH_CODE",
  },
  {
    text: "Position",
    value: "POSITION_CODE",
  },
  {
    text: "Type Salesman",
    value: "EMPLOYEE_TITLE_CODE",
  },
  {
    text: "Customer ID",
    value: "CUSTOMER_ID",
  },
  {
    text: "Customer Name",
    value: "CUSTOMER_NAME",
  },
  {
    text: "Is Print",
    value: "IsPrint",
  },
  {
    text: "Date Print",
    value: "LAST_UPDATE_PRINT",
  },
  {
    text: "Reprint",
    value: "ShouldReprint",
  }
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      isPrintDisabled: true,
      snackbarText: "",
      branchList: [],
      periodeList: [],
      positionList: [],
      yearList: [],
      branch: 'ALL BRANCH',
      position: '',
      periode: "NONE",
      year: "NONE",
      searchRole: "",
      dtLoading: false,
      dtHeaders,
      dtItems: [],
      isSuperUser: JSON.parse(localStorage.getItem("userData")).ORG_ID == 81,
      printerNameList: [],
      printerList: [],
      selectedPrinterName: '',
      selectedPrinter: {},
      moment,
    };
  },
  async mounted() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.loadBranchList(userData.ORG_ID);

    try {
      const zebraDefaultPrinter = await getDefaultDevice();
      const otherZebraPrinters = await getLocalDevices();

      if (
        zebraDefaultPrinter.name !== undefined &&
        zebraDefaultPrinter.name !== null &&
        zebraDefaultPrinter.name !== ''
      ) {
        this.printerList.push(zebraDefaultPrinter);
        this.printerNameList.push(zebraDefaultPrinter.name);
      }

      for (let otherPrinter of otherZebraPrinters.printer) {
        if (!otherPrinter || otherPrinter.uid !== zebraDefaultPrinter.uid) {
          this.printerList.push(otherPrinter);
          this.printerNameList.push(otherPrinter.name);
        }
      }

      this.selectedPrinter = this.printerList[0];
      this.selectedPrinterName = this.printerNameList[0];
    } catch (error) {
      this.showSnackbar('Printer tidak terdeteksi. Silakan jalankan Zebra Browser Print pada perangkat Anda');
    }
  },
  methods: {
    loadBranchList(orgID) {
      this.isLoading = true;
      this.$http
        .post("/call-management/prepareFilter", { orgID: orgID }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          let { data } = res.data;

          if (orgID != 81) {
            this.branch = data.BRANCH_LIST[0].BRANCH_CODE;
          }

          this.branchList = data.BRANCH_LIST;
          this.periodeList = data.PERIODE;
          this.positionList = data.POSITION;
          this.yearList = data.YEAR;

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    async getRelasiPrintList() {
      if (this.branch === '' || this.position === '') {
        this.showSnackbar('Silakan pilih Position terlebih dulu');
        return;
      }

      this.dtLoading = true;
      this.isPrintDisabled = true;
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const res = await this
          .$http
          .get(`/mapping-sales-assignment/getRelasiPrint/${this.position}/${userData.ORG_ID}`, {
            headers: {
              "api-key": this.$apiKey
            }
          });

        let { data } = res.data;

        if (this.branch !== 'ALL BRANCH') {
          data = data.filter(datum => datum.BRANCH_CODE === this.branch);
        }

        this.dtItems = data.length > 0 ? data : [];

        // disable print button if first IsPrint > 0
        this.isPrintDisabled = data.length > 0
          ? data[0].IsPrint > 0
          : true;
      } catch (error) {
        this.showSnackbar(error.toString());
      }

      this.dtLoading = false;
    },
    async sendToPrinter(printer, labelTemplate, data) {
      try {
        const printerStatus = await getPrinterStatus(printer);
        const isReady = printerStatus.isPrinterReady();

        if (isReady) {
          // compile template with data
          const template = Handlebars.compile(labelTemplate);
          const rendered = template(data);

          // print compiled template
          await print(printer, rendered);
        }
      } catch (error) {
        throw error;
      }
    },
    async printQRSingleRelation(relation) {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));

        const printPayload = {
          CUSTOMER_ID_REF: relation.CUSTOMER_ID,
          ORG_ID: relation.ORG_ID,
          ...relation,
        };

        this.dtLoading = true;
        this.showSnackbar(`Sedang mencetak QR untuk ${relation.CUSTOMER_NAME}`);

        await this.sendToPrinter(
          this.selectedPrinter,
          ZPLTemplate.Relation5x4AAMLogo,
          printPayload,
        );
      } catch (error) {
        this.showSnackbar(error.toString());
      }

      this.dtLoading = false;
    },
    async printQRAllRelations() {
      if (this.dtItems.length <= 0) {
        return;
      }

      const userData = JSON.parse(localStorage.getItem("userData"));

      this.dtLoading = true;
      this.isPrintDisabled = true;

      this.showSnackbar('Sedang mencetak QR');
      for (let relation of this.dtItems) {
        if (relation.IsPrint === 1) {
          continue;
        }

        const payload = {
          customer_id: relation.CUSTOMER_ID,
          customer_name: relation.CUSTOMER_NAME,
          org_id: relation.ORG_ID,
          user_id: userData.USER_ID,
        };

        try {
          const printPayload = {
            CUSTOMER_ID_REF: relation.CUSTOMER_ID,
            ORG_ID: relation.ORG_ID,
            ...relation,
          };

          await this.sendToPrinter(
            this.selectedPrinter,
            ZPLTemplate.Relation5x4AAMLogo,
            printPayload,
          );
          await this.$http.post(
            `/mapping-sales-assignment/markRelasiAsPrinted`,
            payload, {
              headers: {
                "api-key": this.$apiKey
              }
            });
        } catch (error) {
          this.showSnackbar(error.toString());
        }
      }

      // refetch marked relasi and stop loading
      this.getRelasiPrintList();
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
